<template>
  <section class="hero-foot">
    <div class="footerBG has-text-centered is-vcentered">
      <h3 class="is-size-4">
        <span class="has-text-weight-bold">{{ title }}</span>
      </h3>
      <a class="has-text-black" href="mailto:aaron@TheM2agency.com">
        <b-icon icon="email-outline"></b-icon>
      </a>
      <a class="has-text-black" href="https://www.instagram.com/them2agency">
        <b-icon icon="instagram"></b-icon>
      </a>
    </div>
  </section>
</template>
<script>
export default {
  name: "Connect",
  props: {
    title: String,
  },
};
</script>
